export { default } from './TextWithImage'
export * from './TextWithImage'
